require('roc-engine/spingames');
require('../common');



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/plugins/slot/public-src/spingames/spingames.js
 **/